/**
 * Zentrale Registrierung aller in dieser Iteration bekannten
 * Preview-/Operator-Flags.
 *
 * Wird einmalig beim App-Start importiert; die Reihenfolge in der UI
 * folgt der Registrierungsreihenfolge hier.
 */
import { definePreviewFlag } from './state';

export const FLAG_GUIDE_ADMIN_PREVIEW = 'guide.adminPreview';

definePreviewFlag({
  id: FLAG_GUIDE_ADMIN_PREVIEW,
  label: 'Admin-Vorschau: inkl. Entwürfe',
  description:
    'Zeigt im Guide und auf der Karte auch noch nicht publizierte Spots. ' +
    'Wirkt nur auf die Admin-Vorschau; normale Nutzer sehen weiterhin ' +
    'ausschliesslich publizierte Spots.',
  scope: 'guide',
  // Flag is only meaningful on Guide- and Map-Surfaces. Strikt
  // begrenzen, sonst taucht es z. B. im Logbuch-Import auf.
  routeMatcher: { routePrefixes: ['/guide', '/map'] },
});
